import { RouterType } from '@online-webinar/router';
import { LiveTranscribePage } from '@online-webinar/webinar-management';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/live-transcribe'].update({
        staticData: { title: { page: 'LiveTranscribe.PageHeading', forWebinar: true } },
        component: authGuard(LiveTranscribePage, { canBroadcast: true })
    });
};
